module.exports = __webpack_public_path__ + "9769914bb9617f555998926729421721.svg";